var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}]},[_c('video-player',{ref:"videoPlayer",staticClass:"vjs-custom-skin",attrs:{"options":_vm.playerOptions},on:{"playing":_vm.onPlayng,"waiting":_vm.parou,"pause":_vm.paused,"ended":_vm.paused,"canplay":_vm.teste,"ready":_vm.playerReadied}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }